const reviewActions = [
  {
    title: '成績を確認する',
    description:
      'ゲーム終了後に統計を開き、これまでのプレイ結果を振り返ります。',
  },
  {
    title: '答えと意味を調べる',
    description: '分からなかった単語は正解表示や辞書リンクを使って復習します。',
  },
  {
    title: '過去問を選ぶ',
    description: 'カレンダーから過去の日付を選び、同じルールで再挑戦できます。',
  },
  {
    title: '結果を共有する',
    description: 'プレイ結果を共有用のテキストにして、学習記録として残せます。',
  },
]

export const GameAchievements: React.FC = () => {
  return (
    <section className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-200 dark:border-gray-700 mb-12">
      <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">
        📝 プレイ後の成績と復習
      </h2>
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-6">
        ゲームの結果を確認して、次の問題で試す入力や、復習する単語を自分で決められます。語彙や会話力の伸び方には個人差があります。
      </p>

      <div className="grid md:grid-cols-2 gap-4">
        {reviewActions.map((action) => (
          <article
            key={action.title}
            className="rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900 p-4"
          >
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">
              {action.title}
            </h3>
            <p className="text-sm text-gray-700 dark:text-gray-300">
              {action.description}
            </p>
          </article>
        ))}
      </div>
    </section>
  )
}
